'use client';

import React, { useState } from 'react';
import { IconButton, InputAdornment, OutlinedInput } from '@mui/material';
import { Eye as EyeIcon } from '@phosphor-icons/react/dist/ssr/Eye';
import { EyeSlash as EyeSlashIcon } from '@phosphor-icons/react/dist/ssr/EyeSlash';
import { ControllerRenderProps, FieldValues, Path } from 'react-hook-form';

export function PasswordInput<TSchema extends FieldValues>({
  field,
  width,
  required = false,
}: {
  field: ControllerRenderProps<TSchema, Path<TSchema>>;
  width: string | number | undefined;
  required?: boolean;
}): React.JSX.Element {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <OutlinedInput
      {...field}
      type={showPassword ? 'text' : 'password'}
      sx={{ width: width || '100%', maxWidth: '100%' }}
      required={required}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            onClick={() => {
              setShowPassword((prev) => !prev);
            }}
            edge="end"
          >
            {showPassword ? <EyeIcon /> : <EyeSlashIcon />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
}
